export default __webpack_public_path__ + "static/media/Khalia.f3b6eb6a.jpg";